// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2BrwW","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2Kbmt"};